import api from '../../../core/api/client';

const LOCAL_STORAGE_KEY = 'calendarEvents';

const normalizeEvents = (payload) => {
  if (Array.isArray(payload)) {
    return payload;
  }

  if (Array.isArray(payload?.events)) {
    return payload.events;
  }

  if (Array.isArray(payload?.data)) {
    return payload.data;
  }

  return [];
};

const readLocalEvents = () => {
  try {
    const raw = localStorage.getItem(LOCAL_STORAGE_KEY);
    const parsed = raw ? JSON.parse(raw) : [];
    return Array.isArray(parsed) ? parsed : [];
  } catch (error) {
    return [];
  }
};

const writeLocalEvents = (events) => {
  localStorage.setItem(LOCAL_STORAGE_KEY, JSON.stringify(events));
};

export const calendarService = {
  async getEvents() {
    const response = await api.get('/calendar/events');
    return normalizeEvents(response.data);
  },

  async createEvent(eventData) {
    try {
      const response = await api.post('/calendar/events', eventData);
      return response.data;
    } catch (error) {
      const events = readLocalEvents();
      const createdEvent = {
        ...eventData,
        id: `evt-${Date.now()}`,
      };
      events.push(createdEvent);
      writeLocalEvents(events);
      return createdEvent;
    }
  },

  async deleteEvent(eventId) {
    try {
      await api.delete(`/calendar/events/${eventId}`);
      return true;
    } catch (error) {
      const events = readLocalEvents().filter((event) => event.id !== eventId);
      writeLocalEvents(events);
      return true;
    }
  },
};
